import React, { useEffect, useState } from "react";
import { DialogActions } from "@material-ui/core";
import DeliveryDetail from "./deliveryDetail";
import CustomDataTable from "../../../../../partials/content/CustomDataTable";
import Illustration from "../../../../../partials/content/Illustration";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import SideBarLayout from "../../../../../partials/content/SideBarLayout";
import {
  cancelDelivery,
  getDeliveries,
} from "../../../../../services/inventory/deliveryService";
import { formatDate } from "../../../../../utils/utils";
import NumberFormat from "react-number-format";
import DeliveryForm from "./deliveryForm";
import ResponsiveEllipsis from "../../../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import Swal from "sweetalert2";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
function DeliveryList({
  salesOrderID = 0,
  operationCardID = 0,
  opWarehouseID = 0,
  warehouseID: warehouseIDprop = 0,
  warehouseName = "",
  outletID: outletIDprop = 0,
  match,
}) {
  let warehouseID = 0;
  let outletID = 0;
  if (salesOrderID === 0) {
    warehouseID = warehouseIDprop;
    if (warehouseID === 0) {
      const { warehouseID: warehouseIDparam = 0 } = match.params;
      warehouseID = warehouseIDparam;
    }
    outletID = outletIDprop;
    if (outletID === 0) {
      const { outletID: outletIDparam = 0 } = match.params;
      outletID = outletIDparam;
    }
  }
  const { reload } = useGlobalData();
  const [deliveries, setDeliveries] = useState([]);
  const [openDeliveryForm, setOpenDeliveryForm] = useState(false);
  const [openDeliveryDetail, setOpenDeliveryDetail] = useState(false);
  const [deliveryID, setDeliveryID] = useState(0);
  useEffect(() => {
    getDeliveriesData(salesOrderID, warehouseID, outletID);
  }, [salesOrderID, warehouseID, outletID, reload]);

  const deliveryDetailColumn = [
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];

  return (
    <React.Fragment>
      {deliveries.length ? (
        <React.Fragment>
          <CustomDataTable
            buttons={[
              {
                name: "New Delivery",
                onClick: () => {
                  setOpenDeliveryForm(true);
                },
                icon: "fas fa-plus-circle",
                color: "primary",
              },
            ]}
            data={deliveries}
            dataDetailColumns={deliveryDetailColumn}
            onRefreshData={() => {
              getDeliveriesData(salesOrderID, warehouseID, outletID);
            }}
            columns={[
              {
                header: "Delivery ID",
                field: "ID",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Delivery Date",
                field: "deliveryDate",
                body: (rowData) => formatDate(rowData.deliveryDate),
                sortable: true,
                filter: true,
              },
              {
                header: "Document Reference",
                field: "deliveryDocRef",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Document Reference ID",
                body: (rowData) => (
                  <React.Fragment>
                    {rowData.salesOrderID > 0
                      ? rowData.salesOrder.salesOrderCode
                      : rowData.salesPosID > 0
                      ? rowData.salesPosID
                      : 0}
                  </React.Fragment>
                ),
                sortable: false,
                filter: false,
              },
              {
                header: "Customer Name",
                field: "customer.customerName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.customer.customerName}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Actions",
                body: (rowData) => (
                  <React.Fragment>
                    <BootstrapTooltip title="Goods Issued Detail">
                      <button
                        type="button"
                        onClick={() => {
                          setDeliveryID(rowData.deliveryOrderID);
                          setOpenDeliveryDetail(true);
                        }}
                        className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                      >
                        <i className="fas fa-list-alt"></i>
                      </button>
                    </BootstrapTooltip>
                    <BootstrapTooltip title="Delete Goods Issued">
                      <button
                        type="button"
                        className="btn btn-icon btn-label-danger btn-circle btn-md mx-1"
                        onClick={() => {
                          cancelDeliveryData(rowData.ID);
                        }}
                      >
                        <i className="fas fa-trash-alt"></i>
                      </button>
                    </BootstrapTooltip>
                  </React.Fragment>
                ),
                sortable: false,
              },
            ]}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Illustration
            imageSource="INVIFO Inventory.png"
            description="Hooray! You're ready to have your first Goods Issued from this warehouse!"
            guidance="Hint: manage your product deliveries to your valuable customer"
            descriptionLeftIcon="fas fa-info-circle kt-font-success"
            size="md"
          ></Illustration>
          <div className="text-center py-3">
            <button
              type="button"
              className="btn btn-primary btn-md btn-pill btn-bold mx-1"
              onClick={() => {
                setOpenDeliveryForm(true);
              }}
            >
              <i className="fas fa-plus-circle"></i>
              New Delivery
            </button>
          </div>
        </React.Fragment>
      )}
      <DialogLayout
        open={openDeliveryDetail}
        title="Goods Issued Detail"
        onCloseDialog={() => {
          setOpenDeliveryDetail(false);
        }}
        minHeight={true}
      >
        <DeliveryDetail deliveryID={deliveryID} />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenDeliveryDetail(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <SideBarLayout
        title="Goods Issued Form"
        visible={openDeliveryForm}
        position="right"
        minWidthPercent="90%"
        onHide={() => handleCloseDeliveryForm()}
      >
        <DeliveryForm
          operationCardID={operationCardID}
          salesOrderID={salesOrderID}
          warehouseID={warehouseID > 0 ? warehouseID : opWarehouseID}
          warehouseName={warehouseName}
          outletID={outletID}
          onSubmitDelivery={() => {
            getDeliveriesData(salesOrderID, warehouseID);
          }}
          onCloseDialog={handleCloseDeliveryForm}
        />
      </SideBarLayout>
    </React.Fragment>
  );

  async function getDeliveriesData(salesOrderID, warehouseID, outletID = 0) {
    const response = await getDeliveries(salesOrderID, warehouseID, outletID);
    const { data } = response.data;
    setDeliveries(data.deliveries);
    handleCloseDeliveryForm();
  }

  async function cancelDeliveryData(deliveryID = 0) {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to delete this Goods Issued ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          cancelDelivery(deliveryID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Deleted",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            getDeliveriesData(salesOrderID, warehouseID, outletID);
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  }

  function handleCloseDeliveryForm() {
    setOpenDeliveryForm(false);
  }
}

export default DeliveryList;
